
module.config(function($stateProvider) {

    $stateProvider.state('student.demographics', {
        url: "/profile",
        templateUrl: "students/demographics/view",
        resolve: {
            participant: function(ModelService, student) {
                return ModelService.get('participant', student.id);
            },
            brandeisData: function(ModelService, student) {
                if (student.is_brandeis) {
                    return ModelService.get('brandeis_data', student.id);
                }
                return {};
            },
            criminalJustice: function(student, ModelService, permissions) {
                if (permissions.viewCriminalJustice && student.has_enrollment) {
                    return ModelService.get('criminal_justice', student.id)
                } else {
                    return {};
                }
            },
        },
        controller: function($scope, participant, criminalJustice, brandeisData) {
            $scope.participant = participant;
            $scope.cj = criminalJustice;
            $scope.brandeisData = brandeisData;
        },
    });

    $stateProvider.state('student.contact', {
        url: "/contact",
        templateUrl: 'students/demographics/contact',
        controller: 'contactInfoController',
        permission: 'viewContactInfo',
        resolve: {
            participant: function(ModelService, student) {
                return ModelService.get('participant', student.id);
            },
        }
    });
});